import { IOption } from "../classes/index";

/**
 * Given a string of available options, if the display text and value it represnts is the exact same,
 * use this function generate a list of IOptions.
 * @param options
 */
export function convertStringToOption(options: Array<string>): Array<IOption> {
    return options.map(option => { return { text: option, value: option } });
}

/**
 * Use this function to populate a list of checkboxes.
 * @param options
 * @param shouldBeChecked
 */
export function convertStringToChecklist(options: Array<string>, shouldBeChecked: string = ""): Array<IOption> {
    const checkedItems = shouldBeChecked.split(",");

    return options.map(option => {
        const isChecked = shouldBeChecked.indexOf(option) > -1;

        return {
            value: String(isChecked),
            text: option
        }
    });
}


// WEBPACK FOOTER //
// ./app/helpers/option-helpers.ts